import {Component,OnInit} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {TypeCodeErreur} from "@domain/common/http/result";
import {MobileConfig} from "@domain/admin/parametre/mobilite/MobileConfig";
import {MobileConfigService} from "@services/admin/parametre/mobilite/mobile-config.service";

/**
 * Onglet paramètres de la mobilité
 *
 * @author Guillaume TRAVOT
 * @date 26/04/2024
 */
@Component({
    host: {'data-test-id': 'mobilite-parametres'},
    templateUrl: './mobilite-parametres.component.html'
})
export class MobiliteParametresComponent implements OnInit {
    /** Configuration mobile courante */
    config: MobileConfig;

    /** Liste des actions du bouton flottant */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     *
     * @param mobileConfigService   Service de gestion de la configuration mobile
     * @param translateService      Service de traduction
     * @param toastr                Service de toast
     */
    constructor(private mobileConfigService: MobileConfigService,
                private translateService: TranslateService,
                private toastr: ToastrService) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Initialisation des actions possibles
        this.listeActions.next([
            {
                type: TypeAction.PRIMARY,
                icone: 'nio icon-sauvegarde',
                libelle: 'global.actions.enregistrer',
                doAction: () => this.saveConfig()
            }
        ]);

        //Chargement de la configuration
        this.loadConfig();
    }

    /**
     * Chargement de la configuration mobile
     */
    loadConfig(): void {
        this.mobileConfigService.loadConfig().subscribe(result => {
            //Création d'une instance à partir des données renvoyées par le back
            this.config = new MobileConfig(result.data.config);
        });
    }

    /**
     * Enregistrement de la configuration mobile
     */
    saveConfig(): void {
        //Appel du service de sauvegarde
        this.mobileConfigService.saveConfig(this.config).subscribe(result => {
            if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                //Notification de succès
                this.toastr.success(this.translateService.instant('global.success.enregistrement'));
            } else {
                //Gestion de l'erreur
                TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastr);
            }
        });
    }

}
